/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();


  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/01_eea9faa5-17e6-49fe-9d79-62ec56be2939.png?v=1764238347",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/02_5e3c2b9d-ef00-4b2e-8433-885a35014e53.png?v=1764238347",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_2_01.png?v=1765167281",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_2_02.png?v=1765167281",
    
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/1_-4.png?v=1764238347",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/2_-4.png?v=1764238347",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_4_01.png?v=1765167281",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_4_02.png?v=1765167281",

    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/1_-6.png?v=1764238347",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/2_-6.png?v=1764238348",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_6_01.png?v=1765167281",
    "https://cdn.shopify.com/s/files/1/0667/2872/2688/files/buy_6_02.png?v=1765167281",
  ];

  jQuery(".sp-scroll2").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  new Swiper(".sp-part5-swiper", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: ".sp-part5-pagination",
      clickable: true,
    },
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $(".sp-nav").height()
            : targetElement.offsetTop;

        // let sptop = document.body.clientWidth <= 1080 ? 194 : 94;
        let sptop = 0;

        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            sptop * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        });
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  $(".sp-pc .product-box").click(function () {
    $(this).addClass("sp-active").siblings().removeClass("sp-active");
  });

  // 套餐色号切换（移动端 + PC）
  // $(".product-part.sp-mobile, .product-part.sp-pc").on("click", ".shade-btn", function () {
  //   var $btn = $(this);
  //   var newImg = $btn.data("img");

  //   if (!newImg) return;

  //   var $box = $btn.closest(".product-box");
  //   var $img = $box.find(".sp-p-img").first();

  //   // 切换按钮选中态
  //   $btn.addClass("active").siblings(".shade-btn").removeClass("active");

  //   // 更新图片
  //   $img.attr("src", newImg);
  //   $img.attr("srcset", newImg);
  // });

  var BASE_SALE_PRICE = window.product[0].price / 100;
  var BASE_COMPARE_PRICE = window.product[0].compare_at_price / 100;

  function formatPrice(val) {
    return (val * 1).toFixed(2);
  }

  // 套餐数量加减（移动端）
  $(".product-part.sp-mobile").on("click", ".qty-btn", function () {
    var $btn = $(this);
    var $box = $btn.closest(".sp-qty-box");
    var $num = $box.find(".qty-num");
    var value = parseInt($num.text(), 10) || 1;

    if ($btn.hasClass("qty-minus")) {
      value = Math.max(1, value - 1);
    } else if ($btn.hasClass("qty-plus")) {
      value = value + 1;
    }

    $num.text(value);
    parentBox.find('.sp-price-per-highlight').html(off_font)
    changePrice(parentBox)
    // $("#sp_price1").html(formatPrice(value * BASE_SALE_PRICE));
    // $("#sp_price2").html(formatPrice(value * BASE_COMPARE_PRICE));
  });

  // 套餐数量加减（PC）
  $(".product-part.sp-pc").on("click", ".qty-btn", function () {
    var $btn = $(this);
    var $box = $btn.closest(".sp-qty-box");
    var $num = $box.find(".qty-num");
    var value = parseInt($num.text(), 10) || 1;

    if ($btn.hasClass("qty-minus")) {
      value = Math.max(1, value - 1);
    } else if ($btn.hasClass("qty-plus")) {
      value = value + 1;
    }

    $num.text(value);
    parentBox.find('.sp-price-per-highlight').html(off_font)
    changePrice(parentBox)
    // $("#sp_price3").html(formatPrice(value * BASE_SALE_PRICE));
    // $("#sp_price4").html(formatPrice(value * BASE_COMPARE_PRICE));
  });

  // $('.sp-btn-style').click(function(){
  //   let num = $(this).siblings('.sp-qty-box').find('.qty-num').html()
  //   num == undefined ? num = 1 : '';
  //       let id = $(this).siblings('.sp-shade-options').find('.shade-btn.active').attr('data-id')
  //       window.location.href = '/cart/' + id + ':' + num
  // })

  let prods = window.product
  function getCur(parentBox) {
    let option0 = parentBox.find('.option0 .active').attr('data-val')
    let option1 = parentBox.find('.sp-offer-title').attr('data-val')
    let option2 = parentBox.find('.option2 .active').attr('data-val')

    // console.log(option0, option1, option2)
    return prods.filter(item => item.option1 == option0 && item.option2 == option1 && item.option3 == option2)[0]
  }
  function changePrice(parentBox) {
    let num = parentBox.find(".qty-num").text() || 1;
    let price = ((getCur(parentBox).price * num) / 100).toFixed(2)
    let compare = ((getCur(parentBox).compare_at_price * num) / 100).toFixed(2)
    price = (price + '').replace('.', ',')
    compare = (compare + '').replace('.', ',')
    parentBox.find('#sp_price1').html(price)
    parentBox.find('#sp_price2').html(compare)
    
    const label = parentBox.find('.sp-offer-title').attr('data-val')
    let off_font = 0
    if (label.includes('2')) {
      off_font = (getCur(parentBox).price / 400).toFixed(2)
    } else if (label.includes('3')) {
      off_font = (getCur(parentBox).price / 600).toFixed(2)
    } else {
      off_font = (getCur(parentBox).price / 200).toFixed(2)
    }
    parentBox.find('.sp-price-per-highlight').html(off_font)
  }
  $(".shade-btn").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    
    const parentBox = $(this).closest('.product-box')
    let option0 = parentBox.find('.option0 .active').index()
    let optionText1 = parentBox.find('.sp-offer-title').attr('data-val')
    let option1 = 0
    if (optionText1.includes('Compra 2')) {
      option1 = 1
    } else if (optionText1.includes('Compra 3')) {
      option1 = 2
    }
    let option2 = parentBox.find('.option2 .active').index()
    console.log(option0, option1, option2)
    let index = option0 + option2 * 2 + option1 * 4
    console.log('index', index)
    parentBox.find('.sp-p-img').first().attr("src", spImgList[index])
    parentBox.find('.sp-p-img').first().attr("srcset", spImgList[index])
    changePrice(parentBox)
  });
  $('.sp-btn-style').click(function () {
    const parentBox = $(this).closest('.product-box')
    let num = parentBox.find(".qty-num").text() || 1;
    window.location.href = '/cart/' + getCur(parentBox).id + ':' + num
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // // 滚动隐藏顶部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-header").height() * $("div#root").css("zoom")
  // ) {
  //   $(".header-wrap").addClass("sp-fixed");
  // } else {
  //   $(".header-wrap").removeClass("sp-fixed");
  // }

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }

  $(window).scroll(function () {
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-header").height() * $("div#root").css("zoom")
    // ) {
    //   $(".header-wrap").addClass("sp-fixed");
    // } else {
    //   $(".header-wrap").removeClass("sp-fixed");
    // }
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
